export const directBookingsSettingsView = {
  loading: "Chargement des paramètres…",

  sidebar: {
    brandTitle: "Annonces",
    brandSub: "Panneau de paramètres",
    searchPlaceholder: "Rechercher…",
    generalLabel: "Général",
    servicesName: "Services et expériences",
    servicesSub: "Une liste pour tout le compte",
    promotionsName: "Promotions",
    promotionsSub: "Créer · Modifier · Gérer",
    globalChip: "GLOBAL",
    inactivePrefix: "Inactif · {type}",
    unitsCount: "{count} unité | {count} unités",
    empty: "Aucune propriété.",
    listingFallbackName: "Annonce",
  },

  status: {
    active: "Actif",
    inactive: "Inactif",
  },

  card: {
    unsavedChanges: "Modifications non enregistrées",
  },

  share: {
    title: "Lien de réservation directe",
    hintPrefix: "Partagez le lien de",
    hintSuffix: "pour recevoir des réservations sans commission.",
    copyTitle: "Copier le lien",
    viewAsVisitor: "Voir en tant que visiteur",
    copied: "Lien copié.",
    copyError: "Impossible de copier le lien.",
    whatsappText: "Bonjour 👋 Voici le lien pour réserver : {link}",
  },

  savebar: {
    unsaved: "Modifications non enregistrées",
    noChanges: "Aucune modification en attente",
    saving: "Enregistrement…",
  },

  drawer: {
    close: "Fermer",
  },

  content: {
    selectListing: "Sélectionnez une annonce",
  },

  units: {
    pickerHint: "Activez ou désactivez la visibilité de chaque unité pour les réservations directes, ou ouvrez-la pour la configurer (tarifs, images, description, services et frais).",
    visible: "Visible",
    hidden: "Masquée",
    showTooltip: "Afficher cette unité dans les réservations directes",
    configure: "Configurer",
  },

  header: {
    listingSub: "Annonce · {count} unité · réservations directes | Annonce · {count} unités · réservations directes",
    unitSub: "Unité · configuration individuelle",
    unitSubCoded: "Unité {code} · configuration individuelle",
    hotelSub: "Hôtel / Camping · réservations directes",
    apartmentSub: "Appartement / Villa · réservations directes",
  },

  tabs: {
    reservations:       { label: "Visibilité de l'annonce",  sub: "Activez-la et définissez le paiement et l'approbation pour les réservations directes" },
    units_list:         { label: "Unités",               sub: "Quelles unités peuvent être réservées" },
    common_images:      { label: "Espaces communs",        sub: "Photos partagées du bâtiment (couverture)" },
    rate_plans:         { label: "Tarifs",               sub: "Plans tarifaires visibles" },
    images:             { label: "Images",              sub: "Galerie de l'annonce" },
    description:        { label: "Description",          sub: "Texte et détails de l'annonce" },
    services:           { label: "Services",            sub: "Services et équipements" },
    promotions:         { label: "Promotions",          sub: "Comment elles s'affichent sur cette annonce" },
    addons:             { label: "Occupation",           sub: "Remises et voyageur supplémentaire" },
    age_rules:          { label: "Règles voyageurs",         sub: "Bébés, enfants et capacité" },
    additional_charges: { label: "Frais et taxes",   sub: "TVA, ménage et frais" },
    web_embed:          { label: "Intégration web",     sub: "Ajoutez le moteur de recherche à votre propre site" },
  },

  save: {
    ratePlans: "Enregistrer les tarifs",
    promotions: "Enregistrer les promotions",
    addons: "Enregistrer les frais",
    ageRules: "Enregistrer les règles",
    additionalCharges: "Enregistrer les frais et taxes",
    payments: "Enregistrer les paiements",
    default: "Enregistrer",
  },

  types: {
    apartment: "Appartement",
    house: "Maison",
    villa: "Villa",
    loft: "Loft",
    room: "Chambre",
    studio: "Studio",
    cabin: "Chalet",
    hotel: "Hôtel",
    hostel: "Auberge",
    camping: "Camping",
  },

  toasts: {
    unitVisible: "Unité visible dans les réservations directes.",
    unitHidden: "Unité masquée.",
    unitUpdateError: "Impossible de mettre à jour l'unité.",
  },

  errors: {
    noUserUuid: "UUID utilisateur introuvable.",
    loadPage: "Impossible de charger la page.",
    loadContext: "Impossible de charger le contexte.",
    saveExec: "Impossible d'exécuter l'enregistrement.",
    saveGeneric: "Impossible d'enregistrer.",
  },

  misc: {
    propertyFallback: "Propriété {id}",
  },
};
